export default {
  loginUser(context) {
    context.commit('login');
  }
}